import { useMemo } from "react";
import Image from "@/components/Image";

interface NormalButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
  disabled?: boolean;
  textClassName?: string;
  showDiamond?: boolean;

  colorType?: "green" | "gray" | "white" | "yellow" | "red" | "learn" | "practice" | "play" | "challenge" | "test";
}

const NormalButton = ({ onClick, className = '', disabled = false, children, colorType = "green", textClassName = '', showDiamond = false }: NormalButtonProps) => {
  if (disabled) {
    return (
      <div className={`rounded-full cursor-not-allowed opacity-60 ${className}`}>
        <button 
          className={`display-text-bold flex flex-row items-center justify-center px-6 py-[10px] rounded-full text-gray-300 font-bold text-xl cursor-not-allowed w-full relative ${textClassName}`}
          disabled={true}
          style={{
            backgroundColor: '#6E6E6E',
          }}
        >
          {children}
          {showDiamond && <Image src="/assets/diamond-3.png" alt="diamond" width={20} height={20} className="w-6 h-6 ml-2" />}
        </button>
      </div>
    );
  }

  const mainColor = useMemo(() => {
    if (colorType === "green") return "#42C52D";
    if (colorType === "gray") return "#919191";
    if (colorType === "white") return "#FFFFFF";
    if (colorType === "yellow") return "#FF9602";
    if (colorType === "red") return "#FA6467";
    // 
    if (colorType === "practice") return "#0E8FD3";
    if (colorType === "learn") return "#80C554";
    if (colorType === "play") return "#EE952E";
    if (colorType === "challenge") return "#FF9602";
    if (colorType === "test") return "#7F2D9E";
  }, [colorType]);

  return (
    <div className={`rounded-full cursor-pointer relative ${className}`}>
      <button 
        className={`display-text-bold flex flex-row items-center justify-center px-4 sm:px-6 py-[10px] rounded-full text-xl transition-all duration-100 w-full relative z-10 hover:brightness-110 whitespace-nowrap truncate ${textClassName}`}
        onClick={onClick}
        style={{
          backgroundColor: mainColor,
          color: colorType === "white" ? "#42C52D" : "#FFFFFF",
          border: colorType === "white" ? `1px solid #DADADA` : "none",
        }}
      >
        {children}
        {showDiamond && <Image src="/assets/diamond-3.png" alt="diamond" width={20} height={20} className="w-6 h-6 ml-2" />}

      </button>
    </div>
  )
}

export default NormalButton;
